module.exports = __webpack_public_path__ + "static/david-1d23abef35c0639edef5f0cf4ca9feb6.png";